import { useLanguage } from "@/i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="relative border-y border-line bg-surface py-4 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span className="font-display text-lg uppercase tracking-[0.15em] text-fog">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-brand" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
